import onFeedbackSubmitted from '../actions/onFeedbackSubmitted';
import { lazyLogFeedback } from 'owa-search-service';
import { orchestrator } from 'satcheljs';

orchestrator(onFeedbackSubmitted, actionMessage => {
    const { scenario, suggestionSetTraceId, yesSelected, feedbackString } = actionMessage;

    lazyLogFeedback.importAndExecute(
        new Date(),
        suggestionSetTraceId,
        yesSelected,
        feedbackString,
        scenario
    );
});
